module.exports = __webpack_public_path__ + "img/logo.be25633.svg";